export const EASE = {
  standard: [0.4, 0.0, 0.2, 1],
  out: [0.0, 0.0, 0.2, 1],
  in: [0.4, 0.0, 1, 1],
} as const;

export const DURATION = {
  micro: 0.15,
  fast: 0.2,
  base: 0.28,
  section: 0.42,
} as const;
